import { Permission } from "./permission.model";

export class Role {
  rolName: string;
  Permissions: Array<Permission>;
  id: number;
}
